const categoryMap = {
  tile: [
    "Tile", 
    "Floor and Wall Tile",
    "Subway Tile",
    "Mosaic",
  ],
  vanities: [
    "Vanity", 
    "Bathroom Vanity",
    "Bath and Vanity",
    "Dining Chairs",
    "Dining Tables",
    "Outdoor Dining Chairs",
    "Lounge Chairs",
  ],
  lighting: [
    "Lighting",
    "Wall Sconce",
    "Picture Light",
    "Linear Lighting",
    "Pendant",
    "Chandelier",
    "Semi-Flush Mount",
    "Linear",
  ],
  mirrors: [
    "Mirrors",
  ]
};

function mapTypeToCategory(rawType) {
  const normalized = rawType?.toLowerCase().trim();
  for (const [category, types] of Object.entries(categoryMap)) {
    if (types.map(type => type.toLowerCase()).includes(normalized)) {
      return category;
    }
  }
  return normalized;
}

window.addEventListener("load", () => {
  const products = document.querySelectorAll(".em-horizontal-product");
  const arrows = document.querySelectorAll(".circle-chevron");
  const buttons = document.querySelectorAll(".em-category-nav__item");

  const btnTile = document.querySelector(".em-category-nav__tile");
  const btnVanities = document.querySelector(".em-category-nav__vanities");
  const btnLighting = document.querySelector(".em-category-nav__lighting");
  const btnMirrors = document.querySelector(".em-category-nav__mirrors");

  const availableTypes = new Set();
  products.forEach(product => {
    const rawType = product.dataset.type?.toLowerCase().trim();
    const mappedType =  mapTypeToCategory(rawType);
    availableTypes.add(mappedType);
  });

  buttons.forEach(btn => {
    const filter = btn.dataset.filter?.toLowerCase().trim();
    if (filter === "all" || availableTypes.has(filter)) {
      btn.classList.remove("em-hidden");
    }
  });

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const filter = btn.dataset.filter;

      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      products.forEach(product => {
        const rawType = product.dataset.type;
        const mappedType =  mapTypeToCategory(rawType);

        if (filter === "all" || mappedType === filter) {
          product.classList.remove("em-hidden"); 
        } else {
          product.classList.add("em-hidden"); 
        }
      });

      const visibleProducts = Array.from(products).filter(
        p => !p.classList.contains("em-hidden")
      );

      if (visibleProducts.length <= 2) {
        arrows.forEach(a => (a.classList.add("em-hidden")));
      } else {
        arrows.forEach(a => (a.classList.remove("em-hidden")));
      }

    });
  });
});
